"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var oembedBoxPlugin = {
  requires: 'widget',
  init: function init(editor) {
    editor.widgets.add('oembed-box', {
      init: function init() {
        this.element.setHtml("<a href=".concat(this.element.getAttribute('url'), ">").concat(this.element.getAttribute('url'), "</a>"));
      },
      upcast: function upcast(elem) {
        return elem.name === 'oembed';
      },
      inline: true
    });
  }
};
var _default = oembedBoxPlugin;
exports.default = _default;